


import Vue from 'vue';

export default Vue.extend({
    data: (): any => ({
        observer: null,
        map: {
            displayed: false,
            coords: {
                lat: 53.648896,
                lng: 19.588093
            }
        }
    }),
    mounted(): void {
        this.observer = new IntersectionObserver(this.displayMap);
        const target = document.querySelector('#kontakt');
        if (target) {
            this.observer.observe(target);
        }
    },
    destroyed(): void {
        this.observer.disconnect();
    },
    methods: {
        displayMap(entries: IntersectionObserverEntry[]) {
            if (entries[0].isIntersecting) {
                this.map.displayed = true;
            }
        }
    }
});
